'use es6';

import I18n from 'I18n';
import { List } from 'immutable';
import { useEffect, useState } from 'react';
import { startOf } from 'reporting-data/lib/dateUtils';
import { Select } from 'foundations-components/transitional/components/Select';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { makeDateRangeByType } from '../lib/DateRangeHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_NUM_YEARS = 18;
const DEFAULT_RANGE_OPTIONS = List(['CUSTOM_MONTH', 'CUSTOM_QUARTER', 'CUSTOM_YEAR']);
const getPastDateUnits = (date, dateUnit, numUnitsPast) => {
  if (numUnitsPast <= 1) {
    return [date];
  }
  return [date, ...getPastDateUnits(date.clone().subtract(1, dateUnit), dateUnit, numUnitsPast - 1)];
};
const formatRangeKey = (date, frequency) => `${frequency}|${date.format('MM')}`;
const buildDateRange = (rangeKey, year) => {
  const [newFreq, monthFormat] = rangeKey.split('|');
  const newDate = `${year}-${monthFormat}-01`;
  return makeDateRangeByType({
    date: newDate,
    rangeType: `CUSTOM_${newFreq}`
  });
};
export default function FullDatePeriodInput({
  rangeType,
  date: initialDate,
  onChange,
  rangeTypeOptions = DEFAULT_RANGE_OPTIONS
}) {
  const present = I18n.moment.portalTz();
  const frequency = rangeType.split('_')[1];
  const currentDate = startOf({
    date: I18n.moment.portalTz(initialDate),
    frequency
  });
  const currentValue = formatRangeKey(currentDate, frequency);
  const [rangeKey, setRangeKey] = useState(currentValue);
  const years = getPastDateUnits(present.clone().add(2, 'year'), 'year', MAX_NUM_YEARS).map(date => date.year());
  const yearOptions = years.map(value => ({
    value,
    label: value
  }));
  const [year, setYear] = useState(currentDate.year());
  const months = getPastDateUnits(present.endOf('year').startOf('month'), 'month', 12).reverse();
  const monthOptions = months.map(date => ({
    value: formatRangeKey(date, 'MONTH'),
    text: date.format('MMMM')
  }));
  const quarterOptions = [months[0], months[3], months[6], months[9]].map(date => ({
    value: formatRangeKey(date, 'QUARTER'),
    text: date.format('[Q]Q')
  }));
  const yearOption = {
    value: formatRangeKey(months[0], 'YEAR'),
    text: I18n.text('DateRangePicker.entireYear')
  };
  const rangeOptions = [...monthOptions, ...quarterOptions, yearOption].filter(({
    value
  }) => {
    const [freq] = value.split('|');
    return rangeTypeOptions.includes(`CUSTOM_${freq}`);
  });
  useEffect(() => {
    setRangeKey(currentValue);
    setYear(year);
  }, [currentValue, year]);
  return /*#__PURE__*/_jsxs(TFlex, {
    children: [/*#__PURE__*/_jsx(Select, {
      "data-test-id": "date-period-select",
      options: rangeOptions,
      value: rangeKey,
      onChange: ({
        target: {
          value
        }
      }) => {
        setRangeKey(value);
        onChange(buildDateRange(value, year));
      }
    }), /*#__PURE__*/_jsx(Select, {
      options: yearOptions,
      value: year,
      onChange: ({
        target: {
          value
        }
      }) => {
        setYear(value);
        onChange(buildDateRange(rangeKey, value));
      }
    })]
  });
}